import React from "react";
import { PortfolioKpis as PortfolioKpiValues } from "../types/ownerPortfolio.types";
import {
  formatOccupancyRate,
  formatPortfolioMoney,
} from "../utils/formatPortfolioDisplay";

interface PortfolioKpisProps {
  kpis: PortfolioKpiValues;
}

const KPI_ITEMS = [
  { key: "total", label: "Imóveis" },
  { key: "rented", label: "Alugados" },
  { key: "vacant", label: "Vagos" },
  { key: "occupancy_rate", label: "Ocupação" },
  { key: "vacant_monthly_rent", label: "Receita mensal vacante" },
] as const;

function formatKpi(key: (typeof KPI_ITEMS)[number]["key"], kpis: PortfolioKpiValues): string {
  if (key === "occupancy_rate") {
    return formatOccupancyRate(kpis.occupancy_rate);
  }

  if (key === "vacant_monthly_rent") {
    return formatPortfolioMoney(kpis.vacant_monthly_rent);
  }

  return kpis[key].toLocaleString("pt-BR");
}

export default function PortfolioKpis({ kpis }: PortfolioKpisProps) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5" data-testid="portfolio-kpis">
      {KPI_ITEMS.map((item) => (
        <div key={item.key} className="rounded-2xl bg-[#1c2128] px-3 py-3">
          <p className="m-0 text-[0.65rem] font-semibold uppercase tracking-wide text-[#6e7681]">
            {item.label}
          </p>
          <p className="m-0 mt-1 truncate text-base font-semibold text-[#f0f6fc] sm:text-lg">
            {formatKpi(item.key, kpis)}
          </p>
        </div>
      ))}
    </div>
  );
}
